import compileVariableUtil from '../../../../static/js/compileVariableUtil'
import templateUtil from '../templateUtil'

export default function (validateItem, formItem, fCreateApi) {
  validateItem.type = null
  // ajaxPost 是自定义字段，与pattern 共用参数（存URL）
  if (validateItem.pattern) {
    validateItem.url = validateItem.pattern
    validateItem.pattern = null
  }

  if (!validateItem.url) {
    console.error('error:rule.pattern(url) is null!')
    return
  }

  validateItem.trigger = 'blur'
  validateItem.validator = (rule, value, callback) => {
    var formData = fCreateApi.getFormData()

    // 配置模板，减少请求数量
    if (validateItem.parameter) {
      var propsCompileData = compileVariableUtil.getCompileVariable(fCreateApi.getFormData(), this)

      let propsCompile = null
      try {
        propsCompile = templateUtil.compileData(validateItem.parameter, propsCompileData)
      } catch (e) {
        console.error('解析失败', e)
        // propsCompile = props;
        // debugger;
      }

      if (propsCompile) formData = propsCompile
    }
    window.$vueApp.$axios
      .post(rule.url, formData)
      .then((res) => {
        if (res.data.code == 200) {
          if (callback) callback()
        } else {
          if (callback) callback(new Error(res.data.msg))
        }
      })
      .catch((res) => {
        window.$vueApp.$cfn.ajax1.catch1(res, window.$vueApp)
      })
  }

  // console.log("validateConverterUtil.converterAdapter:validateItem",
  //   validateItem);
}
